import { Ng2StateDeclaration } from "@uirouter/angular";
import { CompetenceSearchComponent } from "./competence-search.component";
import { SumActivitiesComponent } from "./activity-summation.component";

export const complianceState: Ng2StateDeclaration = {
    name: "app.compliance",
    url: "/compliance",
    abstract: true
};

export const competenceSearchState: Ng2StateDeclaration = {
    name: "app.compliance.competencesearch",
    url: "/competencesearch",
    views: {
        "main-view@app": {
            component: CompetenceSearchComponent
        }
    }
};

export const sumActivitiesState: Ng2StateDeclaration = {
    name: "app.compliance.activitysummation",
    url: "/activitysummation",
    views: {
        "main-view@app": {
            component: SumActivitiesComponent
        }
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/compliance/compliance.states.ts